import { GoogleMapMarkerProps } from './GoogleMap.types'
import { IconProps } from '../icon/Icon.types'
import LocationIcon from '../icon/LocationIcon'

const GoogleMapMarker = ({ ...props }: GoogleMapMarkerProps) => {
    return <LocationIcon size={32} {...(props as IconProps)} />
}

export default GoogleMapMarker
